export const shallowCompare = (
  obj1: Record<string, unknown>,
  obj2: Record<string, unknown>
) =>
  Object.keys(obj1).length === Object.keys(obj2).length &&
  Object.keys(obj1).every(
    (key) =>
      obj2.hasOwnProperty(key) &&
      obj1[key as keyof typeof obj1] === obj2[key as keyof typeof obj2]
  );
